import { Logger } from 'aws-amplify';

export default new Logger('OIMS');